export default {"src":"/_next/static/media/chevronDown_16.8bd83158.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};